// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import EntitySelectorDTO from './EntitySelectorDTO';

interface OriginalExecAgencyDTO extends EntitySelectorDTO { 
  id: number;
  name: string | null;
  isActive: boolean;
}
const OriginalExecAgencyDTO = {
  create: (initValues?: Partial<OriginalExecAgencyDTO> | Record<string, unknown> | null) => {
    return Object.assign(EntitySelectorDTO.create(),
    {
      id: 0,
      name: "",
      isActive: false,
    },
    initValues);
  }
};

export default OriginalExecAgencyDTO;